import TooltipArrow from './components/tooltip-arrow'
import TooltipContent from './components/tooltip-content'
import TooltipProvider from './components/tooltip-provider'
import TooltipRoot from './components/tooltip-root'
import TooltipTrigger from './components/tooltip-trigger'

const TooltipComponent = {
  Root: TooltipRoot,
  Trigger: TooltipTrigger,
  Provider: TooltipProvider,
  Content: TooltipContent,
  Arrow: TooltipArrow
}

export default TooltipComponent
